import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import Contact from '../../image/contact.jpg';
import cl from './Contacts.module.css';

const Contacts = (props) => {
  const position = props.coordinates?.split(', ') || [40.808712, -73.946818];

  return (
    <section className={cl.contact}>
      <img className={cl.big_image} src={Contact} />
      <div className={cl.profile}>
        <div className={cl.info}>
          <h1>Contact us</h1>
        </div>
      </div>
      <div className={cl.main}>
        <p>
          If you have any questions or concerns, please do not hesitate to
          contact us.
        </p>
        <p>We would love to hear from you, contact us on:</p>
        <div className={cl.contacts}>
          <MapContainer
            center={position}
            zoom={12}
            scrollWheelZoom={false}
            style={{ height: '450px', width: '100%', margin: '1rem auto' }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
          <p>
            Email:{' '}
            <a
              style={{ color: 'var(--primary)' }}
              href={'mailto: support@' + props.domain}
            >
              support@{props.domain}
            </a>
          </p>
          <p>{props.shopName} Shop Group</p>
          <p>{props.address}</p>
          <p>
            Tel:{' '}
            <a style={{ color: 'var(--primary)' }} href="tel:+18464947855">
              1-846-494-7855 x844
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
